import { render, staticRenderFns } from "./bunkering.vue?vue&type=template&id=3772fb07&scoped=true"
import script from "./bunkering.vue?vue&type=script&lang=js"
export * from "./bunkering.vue?vue&type=script&lang=js"
import style0 from "./bunkering.vue?vue&type=style&index=0&id=3772fb07&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3772fb07",
  null
  
)

export default component.exports